export default __webpack_public_path__ + "static/ricta1-f25bf0802f9d20a952c1962524e884b4.svg";